import { getSelectBooleanFlag } from './select-flags';

export const selectShouldExposeNewAnalyticsSummaryPage = getSelectBooleanFlag(
  'expose-new-analytics-summary-page'
);
